
import { appState } from './appState.js';
import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';
import { setScroll } from './Scrolls.js';
import { setUrlParam } from './urlTools.js';
import { transGet } from './transTools.js';


export function searchHistoryWin(searchGroup, opener, selectedCountry, addData) {
    const self = this;

    self.searchGroup = searchGroup;
    self.searchKey = searchGroup == 1 ? 'country' : 'city';
    self.sessionKey = searchGroup == 1 ? 'countryListWin' : 'cityListWin';

    if ($('.searchhistorywin').length) {
        // @ts-ignore
        if ($('.searchhistorywin').get(0).searchHistoryWin) { $('.searchhistorywin').get(0).searchHistoryWin.open(opener); return; }
    }
    /* $('.searchhistorywin').each(function() {
        // @ts-ignore
        if (this.searchHistoryWin) { this.searchHistoryWin.close(); }
    }); */


    this.$overlay = $('<span class="overlayOutclicker searchhistory citylist"></span>');
    this.$historylist = $('<div class="searchhistorypop citylistpop"></div>');
    this.$container = $('<div class="searchhistorywin citylistwin"></div>');
    this.$calcTarget = $('.cnsTarget').first();
    this.calcTargetOffsetY = this.$calcTarget.data('offsety') || 0;
    this.created = false;
    this.nextoffset = 0;
    this.perpage = 20;

    this.isselect = true;
    this.searchTitle = transGet('stSearchTitle');

    this.create = function () {
        if (this.created) {
            return;
        }
        this.created = true;

        const html = `
            <div class="in">
                <div class="stickytopstats">
                    <div class="top">
                        <div class="head">
                            <a class="country" href="#"></a>
                            <div class="stats"></div>
                        </div>
                        <form class="search-city-frm" action="/" method="get">
                            <input type="hidden" name="searchid" value="">
                            <input type="hidden" name="searchstr" value="">
                            <select class="citySearchSel" name="citysearchsel" data-prev="" data-dropdown-css-class="citysearch-select-dropdown" data-selection-css-class="citysearch-select" autocomplete="off">
                                <option value="">${self.searchTitle}</option>
                            </select>
                            <button class="searchbutton" type="submit"></button>
                        </form>
                    </div>
                </div>
                <div class="lists">
                    <div class="list">

                    </div>
                    <div class=""><button class="loadMoreResults" type="button" title="Load More"></button></div>
                </div>
            </div>
        `;

        self.$historylist.append(html);
        self.$container.append(self.$overlay).append(self.$historylist);
        $('body').append(self.$container);

        self.$historylist.find('.country').attr('href', addData.urlCountry || '#').html(addData.countryTitle || '');

        // @ts-ignore
        self.$container.get(0).searchHistoryWin = self;

        self.$overlay.on('click', function () {
            self.close();
        });

        self.$historylist.on('click', 'a', function (event) {
            let url = $(this).attr('href');
            if (url.indexOf('javascript') === 0) {
                return;
            }
            event.preventDefault();

            appState.historyInstance.afterPopstate = function () {
                setTimeout(function () {
                    window.location.assign(url);
                }, 20);
                return false;
            };

            const id = $(this).data('id');
            if (id) {
                ajaxWrapNew({
                    method: 'POST',
                    data: {
                        ajax: 1,
                        action: 'selectSearchHistory',
                        searchGroup: self.searchGroup,
                        selectedCountry: selectedCountry,
                        selectedHistory: id
                    },
                    success: function (data) {
                        ResponseDispatcher.handle(data, 'selectSearchHistory');
                        self.close();
                    },
                    dataType: 'json'
                });
                return;
            }

            self.close();
        });

        self.$historylist.on('click', '.loadMoreResults', function (event) {
            self.loadNextCities();
        });

        if (self.isselect) {
            var $searchField = self.$historylist.find('.citySearchSel');
            $searchField.select2({
                dropdownAutoWidth: true,
                width: '100%',
                placeholder: self.searchTitle,
                allowClear: true,
                minimumInputLength: 2,
                tags: false, // Iespējo brīvo tekstu
                ajax: {
                    //url: ajaxUrlSearch,
                    method: 'POST',
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            ajax: 1,
                            action: 'loadSearchHistorySelect',
                            searchGroup: self.searchGroup,
                            selectedCountry: selectedCountry,
                            q: params.term, // search term
                            qp: params.page
                        };
                    },
                    processResults: function (data, params) {
                        params.page = params.page || 1;
                        return {
                            results: data.results,
                            pagination: {
                                more: data.more ? true : false
                            }
                        };
                    },
                    cache: true
                },
                createTag: function (params) {
                    var term = $.trim(params.term);
                    if (term === '') { return null; }
                    return {
                        id: term, // ID ir pats teksts!
                        text: term, // Teksts, ko redz izvēlnē augšā
                        isNew: true // Pazīme mums pašiem
                    };
                },
                insertTag: function (data, tag) {
                    data.unshift(tag);
                }
            });

            $searchField.on('select2:select', function (e) {
                var data = e.params.data;

                // @ts-ignore
                if (data.isNew) {
                    return;
                } else {
                    var text = data.text;

                    ajaxWrapNew({
                        method: 'POST',
                        data: {
                            ajax: 1,
                            action: 'loadCityInfoSearchHistory',
                            searchGroup: self.searchGroup,
                            selectedCountry: selectedCountry,
                            selectedLocation: data.id
                        },
                        success: function (data) {
                            ResponseDispatcher.handle(data, 'loadCityInfoSearchHistory');
                            if (data.url) {
                                appState.historyInstance.afterPopstate = function () {
                                    setTimeout(function () {
                                        window.location.assign(data.url);
                                    }, 20);
                                    return false;
                                };
                                self.close();
                            }
                        },
                        dataType: 'json'
                    });
                }
            });

            $searchField.on('select2:clear', function () {
                $searchField.data('prev', '');
                $searchField.data('blockOpen', true);

                $searchField.val('');
                self.$historylist.find('input[name="searchid"]').val('');
                self.$historylist.find('input[name="searchstr"]').val('');
                self.$historylist.find('.search-city-frm').submit();
            });

            $searchField.on('select2:opening', function (e) {
                if ($searchField.data('blockOpen')) {
                    $searchField.data('blockOpen', false);
                    e.preventDefault();
                }
            });
        }

        self.$historylist.on('submit', '.search-city-frm', function (event) {
            event.preventDefault();

            self.searchCities(self.$historylist.find('input[name="searchstr"]').val());
        });

        $(window).on('jq-resize-end', function (event, w) {
            if (self.$container.is('.opened')) {
                self.setPosition();
            }
        });

        // @ts-ignore
        if (typeof window.citylistRegistered === 'undefined') {
            // @ts-ignore
            window.citylistRegistered = true;
            appState.historyInstance.add(self.searchKey, {
                value: null,
                backCallback: function (change) {
                    try {
                        // @ts-ignore
                        if ($('.searchhistorywin').get(0)?.searchHistoryWin) { $('.searchhistorywin').get(0).searchHistoryWin.close(true); }
                    } catch (e) {

                    }
                },
                checkCallback: function (value) {
                    if ($('.searchhistorywin').length) {
                        try {
                            if ($('.searchhistorywin').is('.opened')) {
                                return true;
                            }
                        } catch (e) {

                        }
                    }
                    return null;
                },
                goBackOnRefresh: true
            });
        }
    };

    self.setPosition = function () {
        const offset = self.$calcTarget.offset();
        const width = self.$calcTarget.width();
        self.$historylist.css({
            top: offset.top + self.calcTargetOffsetY,
            left: offset.left - 10,
            width: width + 10
        });
    };

    self.show = function () {
        self.$container.addClass('opened');
    };

    self.hide = function () {
        self.$container.removeClass('opened');
    };

    self.searchCities = function (searchString) {
        console.log(searchString);
        setUrlParam('searchstr', searchString);

        self.$historylist.find('.list').empty();
        self.loadSearchHistory(null, false, 0).then(() => {
            self.setPosition();
            self.show();
        }).catch(() => {
            self.setPosition();
            self.show();
        });
    };

    self.loadNextCities = function () {
        // todo loading;
        self.loadSearchHistory().then(() => {
            self.setPosition();
            self.show();
        }).catch(() => {
            self.setPosition();
            self.show();
        });
    };

    self.loadSearchHistory = async function (opener, loadFromStart = false, offset = null) {
        return ajaxWrapNew({
            method: 'POST',
            data: $.extend({
                ajax: 1,
                action: 'loadSearchHistory',
                searchGroup: self.searchGroup,
                offset: offset !== null ? offset : self.nextoffset,
                selectedCountry: selectedCountry,
                loadFromStart: loadFromStart ? 1 : 0
            }, addData),
            success: function (data) {
                self.addItems(data);
            },
            dataType: 'json'
        });
    };

    self.addItems = function (data) {
        self.$historylist.find('.loadMoreResults').toggle(data.more);
        self.nextoffset = data.nextoffset;
        const $list = self.$historylist.find('.list');

        if (data.countryStats && (data.countryStats?.connections || data.countryStats?.miracles)) {
            self.$historylist.find('.stats').html(data.countryStats.connections + '<span class="sep10">/</span>' + data.countryStats.miracles);
        } else {
            self.$historylist.find('.stats').empty();
        }

        $.each(data.list, function (i, city) {
            $list.append('<a href="' + city[5] + '" data-id="' + city[0] + '"><span>' + city[2] + '</span> <span>' + (city[3] || city[4] ? city[3] + '<span class="sep">/</span>' + city[4] : '') + '</span></a>');
        });
    };

    self.open = function (opener, nohistory) {
        self.create();

        if (!nohistory) {
            appState.historyInstance.push(self.searchKey);
        }
        if (self.nextoffset) {
            self.setPosition();
            self.show();
            return;
        }

        // Šo vairs neizmantojam, bet gan jau ka vajadzēs slēgt atpakaļ;
        var savedHistoryDataStr = null; //sessionStorage.getItem(self.sessionKey);
        var savedHistoryData = null;
        var loadFromStart = false;
        if (savedHistoryDataStr) {
            try {
                savedHistoryData = JSON.parse(savedHistoryDataStr) || {};
                if (savedHistoryData.country != selectedCountry || (opener && $(opener).data('type') == 'country')) {
                    // dzēšam laukā ? vai vienkārši nelietojam
                    sessionStorage.removeItem(self.sessionKey);
                } else if (savedHistoryData.nextoffset) {
                    self.nextoffset = savedHistoryData.nextoffset - self.perpage;
                    loadFromStart = true;
                    self.$historylist.find('input[name="searchstr"]').val(savedHistoryData.search || '');
                    self.$historylist.find('input[name="searchid"]').val(savedHistoryData.searchid || '');

                    self.$historylist.find('.citySearchSel').each(function () {
                        $(this).append($('<option selected></option>').attr('value', savedHistoryData.searchid || savedHistoryData.search || '').text(savedHistoryData.search || ''));
                    });
                }
            } catch (e) {
                savedHistoryData = null;
            }
        }
        self.loadSearchHistory(opener, loadFromStart).then(() => {
            self.setPosition();
            self.show();
            if (savedHistoryData) {
                setTimeout(function () {
                    setScroll(savedHistoryData.scroll);
                }, 20);
            }
        }).catch(() => {
            self.setPosition();
            self.show();
        });
    };

    self.close = function (nohistory) {
        if (!nohistory && (typeof appState.historyInstance != 'undefined') && appState.historyInstance) {
            appState.historyInstance.go(-1);
            return;
        }

        self.hide();
    };


    self.open(opener);
}

